var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileDownloaded = function SvgFileDownloaded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.629C0 3.244 2.736.5 6.111.5h7.048c1.62 0 3.175.646 4.321 1.795l10.73 10.76A6.136 6.136 0 0 1 30 17.39v15.982c0 3.385-2.736 6.129-6.111 6.129H6.112C2.736 39.5 0 36.756 0 33.371V6.63Zm6.111-2.786a2.782 2.782 0 0 0-2.778 2.786V33.37a2.782 2.782 0 0 0 2.778 2.786h17.777a2.782 2.782 0 0 0 2.778-2.786V17.389c0-.059-.002-.117-.005-.175h-7.217c-3.375 0-6.111-2.744-6.111-6.129V3.848a2.707 2.707 0 0 0-.174-.006H6.11Zm10.556 2.364v4.879a2.782 2.782 0 0 0 2.777 2.785h4.865l-7.643-7.664Z",
    fill: "#BEBDF7"
  })));
};
export default SvgFileDownloaded;